/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/core';
import { contentCSS, contentCSSWrapper, descriptionCSS, elemAfterCSS, elemBeforeCSS, truncateCSS } from './styles';

var defaultRender = function defaultRender(Component, props) {
  return jsx(Component, props);
};

var BaseItem = function BaseItem(_ref) {
  var children = _ref.children,
      description = _ref.description,
      iconAfter = _ref.iconAfter,
      iconBefore = _ref.iconBefore,
      overrides = _ref.overrides;
  var renderTitle = overrides && overrides.Title && overrides.Title.render || defaultRender;
  return jsx("div", {
    css: contentCSSWrapper
  }, iconBefore && jsx("span", {
    "data-item-elem-before": true,
    css: elemBeforeCSS
  }, iconBefore), children && jsx("span", {
    css: contentCSS
  }, jsx(ClassNames, null, function (_ref2) {
    var css = _ref2.css;
    return renderTitle('span', {
      children: children,
      className: css(truncateCSS),
      'data-item-title': true
    });
  }), description && jsx("span", {
    "data-item-description": true,
    css: descriptionCSS
  }, description)), iconAfter && jsx("span", {
    "data-item-elem-after": true,
    css: elemAfterCSS
  }, iconAfter));
};

export default BaseItem;